<div *ngrxLet="params$; let params;"
     [style.width.px]="params?.eGridCell?.clientWidth > form?.clientWidth ?
        params?.eGridCell?.clientWidth : form.clientWidth"
     cdkTrapFocus>
  <form #form
        [formGroup]=editorFormGroup
        [ngClass]="{ 'border-[#D62D1A]': editorFormGroup.invalid && editorFormGroup.touched }"
        class="flex flex-col min-w-fit">
    <div id="formArrayContainer"
         class="min-w-fit max-h-[223px] overflow-y-auto"
         formArrayName="customServices">
      @for (_ of getCustomServicesFormArray()?.controls; track _; let i = $index; let last = $last) {
        <div [formGroupName]="i" class="flex flex-col">
          <mat-form-field appearance="fill"
                          class="textFormField">
            <mat-label>{{ getLabel('serviceName') }}</mat-label>

            <input #serviceNameInput
                   type="text"
                   matInput
                   appGxInput
                   formControlName="serviceName">

            @if (getErrorMessage(i, 'serviceName')) {
              <mat-error class="flex items-center"
                         [matTooltip]="getErrorMessage(i, 'serviceName')">
                <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
                <span class="truncate">{{ getErrorMessage(i, 'serviceName') }}</span>
              </mat-error>
            }

            <div class="removeIcon"
                 (click)="deleteCustomService(i)">
              <mat-icon svgIcon="remove_circle_outline"></mat-icon>
            </div>

            @if (serviceNameInput?.value?.length) {
              <div class="copyIcon"
                   (click)="copyServiceToClipboard(i)">
                <mat-icon svgIcon="content_copy"></mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field appearance="fill"
                          class="textFormField">
            <mat-label>{{ getLabel('serviceDescription') }}</mat-label>

            <textarea type="text"
                      matInput
                      appGxInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="1"
                      formControlName="serviceDescription"></textarea>

            @if (getErrorMessage(i, 'serviceDescription')) {
              <mat-error class="flex items-center"
                         [matTooltip]="getErrorMessage(i, 'serviceDescription')">
                <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
                <span class="truncate">{{ getErrorMessage(i, 'serviceDescription') }}</span>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill"
                          class="textFormField">
            <mat-label>{{ getLabel('serviceCategoryId') }}</mat-label>

            <input type="text"
                   matInput
                   appGxInput
                   formControlName="serviceCategoryId">

            @if (getErrorMessage(i, 'serviceCategoryId')) {
              <mat-error class="flex items-center"
                         [matTooltip]="getErrorMessage(i, 'serviceCategoryId')">
                <mat-icon svgIcon="error" class="errorIcon"></mat-icon>
                <span class="truncate">{{ getErrorMessage(i, 'serviceCategoryId') }}</span>
              </mat-error>
            }
          </mat-form-field>

          @if (!last) {
            <mat-divider class="mb-[22px]"></mat-divider>
          }

        </div>

      }
    </div>

    <div class="flex flex-col min-w-fit">
      @if (getCustomServicesFormArray()?.controls?.length) {
        <mat-divider class="mb-[10px]"></mat-divider>
      }

      <button #createButton
              mat-stroked-button
              type="button"
              color="primary"
              (click)="addCustomService()"
              class="mb-[10px] w-[fit-content]">
        <mat-icon class="addCustomServiceIcon" svgIcon="add_circle_outline"></mat-icon>
        New custom service
      </button>
    </div>

  </form>
</div>
